import { render, staticRenderFns } from "./PeriodCreate.vue?vue&type=template&id=1dd5e9c9"
import script from "../../controllers/academic_period/period-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/academic_period/period-create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports